import {ChoiceId, TimelineId} from "@storyverseco/svs-story-suite";

export enum WinConditionType {
    CHOICES = 'choices'
}

export type Conditions =  Record<TimelineId, ChoiceId>;

export interface WinCondition {
    conditionType: WinConditionType,
    conditions: Conditions
}


